export default __webpack_public_path__ + "static/media/PAGES_JAUNES.b303a65d.png";